import { Navigate, RouteObject } from "react-router-dom";
import Home from "../pages/Home/Home";
import CallBack from "../pages/Auth/CallBack";
import Login from "../pages/Auth/Login";
import AccessDenied from "../pages/AccessDenied/AccessDenied";
import NotFound from "../pages/NotFound/NotFound";
import ErrorServer from "../pages/ErrorServer/ErrorServer";
import Logout from "src/pages/Auth/Logout";
import ChangePassword from "src/pages/Auth/ChangePassword";
import BriefList from "src/pages/Brief/List/BriefList";
import BriefView from "src/pages/Brief/View/BriefView";
import BriefForm from "src/pages/Brief/Form/BriefForm";
import MeList from "src/pages/Brief/MeList/MeList";

const routers: RouteObject[] = [
  { path: "/", element: <Home /> },
  {
    path: "/login",
    children: [
      { path: "", element: <Login /> },
      { path: "oauth2/code/cognito", element: <CallBack /> },
    ],
  },
  {
    path: "logout",
    element: <Logout />,
  },
  {
    path: "change-password",
    element: <ChangePassword />,
  },
  {
    path: "/brief",
    children: [
      {
        path: "",
        element: <Navigate to="/brief/crear/campaign" replace />,
      },
      {
        path: "crear/:type",
        element: <BriefForm />,
      },
      {
        path: "editar/:type/:id",
        element: <BriefForm />,
      },
      {
        path: "list",
        element: <BriefList />,
      },
      {path: "me", element: <MeList />},
      { path: "ver/:id", element: <BriefView /> },
    ],
  },
  {
    path: "acceso-restringido",
    element: <AccessDenied />,
  },
  {
    path: "error-server",
    element: <ErrorServer />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routers;
